const WS_PALETTES = [
  { bg: 'rgba(99,102,241,0.12)',  border: 'rgba(99,102,241,0.35)',  text: 'rgba(67,56,202,0.9)'   },
  { bg: 'rgba(139,92,246,0.12)',  border: 'rgba(139,92,246,0.35)',  text: 'rgba(109,40,217,0.9)'  },
  { bg: 'rgba(59,130,246,0.12)',  border: 'rgba(59,130,246,0.35)',  text: 'rgba(29,78,216,0.9)'   },
  { bg: 'rgba(20,184,166,0.12)',  border: 'rgba(20,184,166,0.35)',  text: 'rgba(15,118,110,0.9)'  },
  { bg: 'rgba(236,72,153,0.12)',  border: 'rgba(236,72,153,0.35)',  text: 'rgba(157,23,77,0.9)'   },
  { bg: 'rgba(245,158,11,0.12)',  border: 'rgba(245,158,11,0.35)',  text: 'rgba(146,64,14,0.9)'   },
  { bg: 'rgba(16,185,129,0.12)',  border: 'rgba(16,185,129,0.35)',  text: 'rgba(6,95,70,0.9)'     },
  { bg: 'rgba(239,68,68,0.12)',   border: 'rgba(239,68,68,0.35)',   text: 'rgba(185,28,28,0.9)'   },
];

// Maps PROJECT_ICON_COLOURS hex values to palette-style translucent tokens
const PROJECT_COLOUR_MAP = {
  '#64748b': { bg: 'rgba(100,116,139,0.12)', border: 'rgba(100,116,139,0.35)', text: 'rgba(51,65,85,0.9)'    },
  '#ef4444': { bg: 'rgba(239,68,68,0.12)',   border: 'rgba(239,68,68,0.35)',   text: 'rgba(185,28,28,0.9)'   },
  '#f97316': { bg: 'rgba(249,115,22,0.12)',  border: 'rgba(249,115,22,0.35)',  text: 'rgba(154,52,18,0.9)'   },
  '#eab308': { bg: 'rgba(234,179,8,0.12)',   border: 'rgba(234,179,8,0.35)',   text: 'rgba(113,63,18,0.9)'   },
  '#84cc16': { bg: 'rgba(132,204,22,0.12)',  border: 'rgba(132,204,22,0.35)',  text: 'rgba(54,83,20,0.9)'    },
  '#22c55e': { bg: 'rgba(34,197,94,0.12)',   border: 'rgba(34,197,94,0.35)',   text: 'rgba(22,101,52,0.9)'   },
  '#14b8a6': { bg: 'rgba(20,184,166,0.12)',  border: 'rgba(20,184,166,0.35)',  text: 'rgba(15,118,110,0.9)'  },
  '#06b6d4': { bg: 'rgba(6,182,212,0.12)',   border: 'rgba(6,182,212,0.35)',   text: 'rgba(14,116,144,0.9)'  },
  '#3b82f6': { bg: 'rgba(59,130,246,0.12)',  border: 'rgba(59,130,246,0.35)',  text: 'rgba(29,78,216,0.9)'   },
  '#6366f1': { bg: 'rgba(99,102,241,0.12)',  border: 'rgba(99,102,241,0.35)',  text: 'rgba(67,56,202,0.9)'   },
  '#8b5cf6': { bg: 'rgba(139,92,246,0.12)',  border: 'rgba(139,92,246,0.35)',  text: 'rgba(109,40,217,0.9)'  },
  '#a855f7': { bg: 'rgba(168,85,247,0.12)',  border: 'rgba(168,85,247,0.35)',  text: 'rgba(126,34,206,0.9)'  },
  '#ec4899': { bg: 'rgba(236,72,153,0.12)',  border: 'rgba(236,72,153,0.35)',  text: 'rgba(157,23,77,0.9)'   },
  '#f43f5e': { bg: 'rgba(244,63,94,0.12)',   border: 'rgba(244,63,94,0.35)',   text: 'rgba(159,18,57,0.9)'   },
  '#fb923c': { bg: 'rgba(251,146,60,0.12)',  border: 'rgba(251,146,60,0.35)',  text: 'rgba(154,52,18,0.9)'   },
  '#78716c': { bg: 'rgba(120,113,108,0.12)', border: 'rgba(120,113,108,0.35)', text: 'rgba(68,64,60,0.9)'    },
};

export function getWorkspacePalette(str = '') {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return WS_PALETTES[Math.abs(hash) % WS_PALETTES.length];
}

export function getProjectColourPalette(hex = '') {
  const key = hex?.toLowerCase?.();
  return PROJECT_COLOUR_MAP[key] || getWorkspacePalette(hex);
}
